import React from 'react';
import { render } from 'react-dom';
import { PsdParseModalContainer } from './psd-parse-modal-container';
import { IPsdParseModalProps } from './type';

export class PsdParseModal {
    static show(params: IPsdParseModalProps) {
        if (!document.getElementById('psd-parse-modal')) {
            const el = document.createElement('div');
            el.className = 'psd-parse-modal';
            el.id = 'psd-parse-modal';
            document.body.appendChild(el);
        }

        const newParams = {
            ...params,
            finishCallback: (data: any) => {
                if (params.finishCallback) {
                    params.finishCallback(data);
                }
                PsdParseModal.close();
            },

            closeCallback: () => {
                if (params.closeCallback) {
                    params.closeCallback();
                }
                PsdParseModal.close();
            },
        };

        render(<PsdParseModalContainer {...newParams} />, document.getElementById('psd-parse-modal') as HTMLElement);
    }

    static close() {
        render(<div></div>, document.getElementById('psd-parse-modal') as HTMLElement);
    }
}
